import { render, staticRenderFns } from "./PriceItem.vue?vue&type=template&id=d73b64c4&"
import script from "./PriceItem.vue?vue&type=script&lang=js&"
export * from "./PriceItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports